import { FC } from 'react';
import { LazyReferenceInput } from './LazyAutoCompleteInput';

const SUPERVISOR_ROLE_FILTER = ',Supervisor,';

interface SupervisorReferenceInputProps {
  source: string;
  label?: string;
  activeOnly?: boolean;
  alwaysOn?: boolean;
  resettable?: boolean;
  allowEmpty?: boolean;
  'data-cy'?: string;
}

// When a search value is present the role/active constraints must live inside the
// `s` object: the dataProvider's composeQuery short-circuits to `search(s)` and drops
// any sibling flat filter keys, which would otherwise leak non-supervisors/inactive users.
const buildFilterToQuery = (activeOnly: boolean) => (value: string) => {
  if (value) {
    const and: Record<string, any>[] = [
      { roleNames: { $cont: SUPERVISOR_ROLE_FILTER } },
    ];
    if (activeOnly) and.push({ active: { $eq: true } });
    and.push({ fullName: { $contL: value } });
    return { s: { $and: and } };
  }
  const base: Record<string, any> = {
    'roleNames||$cont': SUPERVISOR_ROLE_FILTER,
  };
  if (activeOnly) base['active||$eq'] = true;
  return base;
};

export const SupervisorReferenceInput: FC<SupervisorReferenceInputProps> = ({
  label = 'Supervisor',
  activeOnly = false,
  ...rest
}) => (
  <LazyReferenceInput
    {...rest}
    label={label}
    reference="user-role-region-list"
    sort={{ field: 'firstName', order: 'ASC' }}
    optionText="fullName"
    optionValue="id"
    filterToQuery={buildFilterToQuery(activeOnly)}
  />
);
